var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoRealMoney40X40 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27775",
    "data-name": "Group 27775",
    transform: "translate(19087 6922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_gambling_2105220",
    transform: "translate(-19082 -6917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M9.269,13.938a7.013,7.013,0,1,0,5.692,5.754A7.029,7.029,0,0,0,9.269,13.938Zm-.25,12.885A6.062,6.062,0,1,1,6.955,14.877,6.062,6.062,0,1,1,9.019,26.823Z",
    transform: "translate(-1.036 -6.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M29.752,29.613,28.5,27.486a.338.338,0,0,0-.5-.125l-1,.563a7.507,7.507,0,0,0,1.564,2.752l1-.563A.375.375,0,0,0,29.752,29.613Z",
    transform: "translate(-10.76 -11.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M38.115,33.5H35.675a.4.4,0,0,0-.375.375V35a6.679,6.679,0,0,0,1.564.188A6.3,6.3,0,0,0,38.427,35V33.875A.35.35,0,0,0,38.115,33.5Z",
    transform: "translate(-13.869 -13.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M44.186,18.363l1.251,2.127a.338.338,0,0,0,.5.125l1-.563A7.507,7.507,0,0,0,45.375,17.3l-.938.563A.416.416,0,0,0,44.186,18.363Z",
    transform: "translate(-17.189 -7.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M28.176,20.615a.338.338,0,0,0,.5-.125l1.251-2.127a.392.392,0,0,0-.125-.5l-.938-.563A6.34,6.34,0,0,0,27.3,20.052Z",
    transform: "translate(-10.873 -7.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M45.429,27.486l-1.251,2.127a.392.392,0,0,0,.125.5l1,.563a6.34,6.34,0,0,0,1.564-2.752l-.938-.563A.338.338,0,0,0,45.429,27.486Z",
    transform: "translate(-17.18 -11.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M35.3,15.113a.4.4,0,0,0,.375.375h2.439a.4.4,0,0,0,.375-.375V13.988a6.68,6.68,0,0,0-1.564-.188,6.3,6.3,0,0,0-1.564.188v1.126Z",
    transform: "translate(-13.869 -6.107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M36.974,21.047a2.537,2.537,0,0,0-3.127,3.127A2.476,2.476,0,0,0,35.6,25.925,2.537,2.537,0,0,0,38.725,22.8,2.284,2.284,0,0,0,36.974,21.047Z",
    transform: "translate(-13.291 -8.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M40.523,19.691l-.813.5a.957.957,0,0,1-1.376-.375L37.083,17.69a.957.957,0,0,1,.375-1.376l.813-.438A6.963,6.963,0,0,0,35.894,14.5v.938a.988.988,0,0,1-1,1H32.454a.988.988,0,0,1-1-1V14.5a6.963,6.963,0,0,0-2.377,1.376l.813.438a1.037,1.037,0,0,1,.375,1.376l-1.251,2.127a.957.957,0,0,1-1.376.375l-.813-.5a9.369,9.369,0,0,0-.125,1.376,9.369,9.369,0,0,0,.125,1.376l.813-.5a.957.957,0,0,1,1.376.375l1.251,2.127a1.006,1.006,0,0,1-.375,1.376l-.813.438a6.963,6.963,0,0,0,2.377,1.376V26.7a.988.988,0,0,1,1-1h2.439a.988.988,0,0,1,1,1v.938a6.963,6.963,0,0,0,2.377-1.376l-.813-.438a1.022,1.022,0,0,1-.375-1.376l1.251-2.127a.957.957,0,0,1,1.376-.375l.813.5a9.368,9.368,0,0,0,.125-1.376A9.368,9.368,0,0,0,40.523,19.691Zm-6.88,4.566a3.19,3.19,0,0,1-3.19-3.127,3.159,3.159,0,1,1,6.317,0A3.1,3.1,0,0,1,33.643,24.257Z",
    transform: "translate(-10.648 -6.369)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M8.046,16.933a5.069,5.069,0,0,0-4,4.066,5.134,5.134,0,1,0,4-4.066Zm1.626,8.444v.876H8.546v-.876a3.175,3.175,0,0,1-1.126-.563,3.122,3.122,0,0,1-.688-1.063L7.8,23.375a1.708,1.708,0,0,0,.563.751c.625.5,1.814.375,1.814-.625,0-.813-.876-1-1.876-1.439A1.934,1.934,0,0,1,6.92,20.248,1.793,1.793,0,0,1,8.484,18.5v-.813H9.609V18.5a1.721,1.721,0,0,1,.938.5,2.624,2.624,0,0,1,.563.876l-1.063.375a1.017,1.017,0,0,0-1.063-.688c-.625,0-.876.313-.876.688,0,.563.688.813,1.251,1,1,.438,1.564.688,1.876,1.5a3.139,3.139,0,0,1,.125.751A1.8,1.8,0,0,1,9.672,25.377Z",
    transform: "translate(-2.126 -7.238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M22.294,9.819l5.442-4.128L22.294,1.5V3.627H14.1V7.692h8.194Z",
    transform: "translate(-5.929 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M19.542,35.2,14.1,39.328l5.442,4.191V41.392h8.194V37.327H19.542Z",
    transform: "translate(-5.929 -14.122)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoRealMoney40X40);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_real_money_40x40.a9d8640f593ef4d754d8406cb1d29e24.svg";